module.exports = __webpack_public_path__ + "img/BMWGroup_BMW_MINI_White-Colour_RGB.b374fb5c.png";